import { axiosWithAuth } from "helpers";

export const merchantHistoryTabService = {
	getMerchantHistory,
};

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 50;

function getMerchantHistory({ page, id }) {
	const options = {
		method: "GET",
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
		},
		url: `${API_URL}/api/modifications/merchants/${id}`,
	};

	return axiosWithAuth(options);
}
